import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Add, Remove } from '@material-ui/icons';
import classnames from 'classnames';

import styles from './css/AnchorStats.module.css';


function AnchorStats(props) {
  const { anchor } = props;
  const {
    blog,
    biography,
    Since,
    isNakedNewsLive,
    isPastAnchor,
  } = anchor || {};
  const [showStats, setShowStats] = useState(false);

  const toggleStatsView = useCallback(() => {
    setShowStats(!showStats);
  }, [showStats]);

  const statsButton = useMemo(() => {
    const button = !showStats ? <Add /> : <Remove />;

    return button;
  }, [showStats]);

  return (
    <div
      className={
        classnames(
          [styles.anchorPedigreeStats],
          {
            [styles.pastAnchor]: isPastAnchor,
            [styles.currentAnchor]: !isPastAnchor,
          }
        )}
    >
      <button className={styles.statsTitleMobile} onClick={toggleStatsView}>
        <h2>
          Stats {statsButton}
        </h2>
      </button>
      <ul
        className={classnames(
          [styles.listUnstyled],
          { [styles.showStats]: showStats }
        )
        }
      >
        {blog && (
          <li>
            <strong style={{ marginLeft: 5 }}>Blog: </strong>
            <a
              href={blog}
              rel="noopener noreferrer"
              target="_blank"
            >
              My blog
            </a>
          </li>
        )}
        {biography.birthdate && (
          <li>
            <p>
              <strong>Birthday:</strong>
              {biography.birthdate}
            </p>
          </li>
        )}
        {biography.height && (
          <li>
            <p>
              <strong>Height:</strong>
              {biography.height}
            </p>
          </li>
        )}
        {biography.measurements && (
          <li>
            <p>
              <strong>Measurements:</strong>
              {biography.measurements}
            </p>
          </li>
        )}
      </ul>
      <ul
        className={classnames(
          [styles.listUnstyled],
          { [styles.showStats]: showStats }
        )
        }
      >
        {biography.specialty && (
          <li>
            <p>
              <strong>Specialty:</strong>
              {biography.specialty}
            </p>
          </li>
        )}
        {biography.turnOns && (
          <li>
            <p>
              <strong>Turn Ons:</strong>
              {biography.turnOns}
            </p>
          </li>
        )}
        {biography.turnOffs && (
          <li>
            <p>
              <strong>Turn Offs:</strong>
              {biography.turnOffs}
            </p>
          </li>
        )}
        {Since && (
          <li>
            <p>
              <strong>Since:</strong>
              {Since}
            </p>
          </li>
        )}
      </ul>
      <ul
        className={classnames(
          [styles.listUnstyled],
          { [styles.showStats]: showStats }
        )
        }
      >
        {biography.hobbies && !isNakedNewsLive && (
          <li>
            <p>
              <strong>Hobbies:</strong>
              {biography.hobbies}
            </p>
          </li>
        )}
      </ul>
    </div>
  );
}

export default AnchorStats;

AnchorStats.propTypes = { anchor: PropTypes.object.isRequired };
